import React from 'react';
import { Icon, IconTypeKey } from 'hfs-common-ui';
import * as S from './styled';

export interface Props {
  icon: IconTypeKey;
  activeIcon: IconTypeKey;
  isActive: boolean;
  id?: string;
}
const NavIcon = ({ icon, id, activeIcon, isActive }: Props) => {
  return isActive ? (
    <S.NavIconContainer data-testid="activeIcon" id={id}>
      <Icon type={activeIcon} />
    </S.NavIconContainer>
  ) : (
    <S.NavIconContainer data-testid="normalIcon" id={id}>
      <Icon type={icon} />
    </S.NavIconContainer>
  );
};

export default NavIcon;
